import { Chip, Flex } from "@ir/ui";
import { OrganizationBrandStatusSwitch } from "./OrganizationBrandStatusSwitch";

export interface BrandStatusControlProps {
  brandId: number;
  brandIsActive?: boolean | null;
  brandDeletedAt?: string | null;
  onUpdateBrandStatus?: (brandId: number, brandIsActive: boolean) => Promise<void>;
  onUpdateSuccess?: () => void;
}

export const BrandStatusControl = ({
  brandId,
  brandIsActive,
  brandDeletedAt,
  onUpdateBrandStatus,
  onUpdateSuccess,
}: BrandStatusControlProps) => {
  return (
    <Flex align="center" gap={0.5}>
      {brandDeletedAt && (
        <Chip size="small" label="Deleted" color="error" borderless />
      )}
      {!brandDeletedAt && (
        <OrganizationBrandStatusSwitch
          brandId={brandId}
          brandIsActive={brandIsActive ?? false}
          onUpdate={onUpdateBrandStatus ?? (() => Promise.resolve())}
          onUpdateSuccess={onUpdateSuccess ?? (() => {})}
        />
      )}
    </Flex>
  );
};
